export default __webpack_public_path__ + "static/media/star-outline.1b8ff226.svg";